import { takeLatest, put, call, select } from 'redux-saga/effects';
import { CURRENT_VISITORS_SAGA } from "../sagaTypes";
import { loaderAction, currentVisitorsAction, firstCurrentVisitorsRequestAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/current_visitors`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCurrentVisitors(args) {
    const user = yield select(state => state.user);
    const currentVisitors = yield select(state => state.currentVisitors);
    const firstCurrentVisitorsRequest = yield select(state => state.firstCurrentVisitorsRequest);

    if (args.data.preloader) {
        yield put(loaderAction(true));
    }

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', args.data.establishment);
        formData.append('subscription_type', args?.data?.subscription_type || '');
        formData.append('subscription_coach', args?.data?.subscription_coach || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Проверяем наличие новых пользователей при каждом обновлении, кроме первого
            if ((user.settings?.new_user === '0' || user.settings?.new_user === undefined) && firstCurrentVisitorsRequest) {

                // Пробегаем по полученным пользователям и находим тех, кого нет в currentVisitors
                response.visitors.forEach(elem => {

                    if (!currentVisitors.some(el => el.workout_id === elem.workout_id)) {
                        growl({
                            type: 'success',
                            message: elem?.user?.name ? `Новый посетитель: ${ elem.user.name }` : 'Новый посетитель',
                            time: 50000
                        });
                    }
                });
            }
            else {
                yield put(firstCurrentVisitorsRequestAction(true));
            }

            yield put(currentVisitorsAction(response.visitors));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherCurrentVisitors() {
    yield takeLatest(CURRENT_VISITORS_SAGA, workerCurrentVisitors);
}